import React from 'react';
import { Checkbox, Form } from 'semantic-ui-react';
import { MAX_KEY_FAILURE_THRESHOLD_V95 } from './keyPolicyConfigV95';

const ChannelKeyPolicyV95 = ({ config, onChange, t }) => (
  <>
    <Form.Field>
      <Checkbox
        toggle
        label={t('channel.edit.key_failure_policy.auto_disable')}
        name='disable_key_on_failure'
        checked={config.disable_key_on_failure !== false}
        onChange={(event, { checked }) =>
          onChange(event, { name: 'disable_key_on_failure', value: checked })
        }
      />
    </Form.Field>
    {config.disable_key_on_failure !== false && (
      <Form.Input
        label={t('channel.edit.key_failure_policy.threshold_v95')}
        name='key_failure_threshold_v95'
        type='number'
        min={1}
        max={MAX_KEY_FAILURE_THRESHOLD_V95}
        step={1}
        value={config.key_failure_threshold_v95 ?? 1}
        onChange={onChange}
      />
    )}
  </>
);

export default ChannelKeyPolicyV95;
